(function () {
  'use strict';
  angular.module('vcfinance.turnover')
    .component('turnover', {
      restrict: 'E',
      templateUrl: 'vcfinance/turnover/turnover-component.tpl.html',
      controllerAs: 'vm',
      controller: ['Turnover', '$log', '$http',
        function (Turnover, $log, $http) {
          let vm = this;

          // set default view on page open
          vm.view = 'summary';

          // vm.today = moment().locale('de-at').format('ll');
          // vm.thisday = moment().format('YYYY-MM-DD').toString();
          // vm.thismonth = moment().format('YYYY-MM').toString();
          // vm.thisyear = moment().format('YYYY').toString();

          // NOTE TO SELF: Statistics with Stornos and Discounts is REALLY tricky!!!!!!
          // please note the following

          // inv.netto = sum of net prices
          // inv.totalbefore = brutto sum before discount
          // inv.tax = tax sum before discount
          // inv.taxdiscounted = discounted tax sum
          // inv.nettodiscounted = nett sum discounted, also set when discount was 0
          // inv.discounttaxsum = array with taxes per steuersatz, post discount, also set when discount was 0

          // some fun new queries to cashinvoices
          // [{$match: {test:false}},{$group:{_id: {year: {$substr:['$date',0,4]},month: {$substr: ['$date',5,2]} },count: {$sum:1}, monthlytotal: {$sum: '$total'}, monthlytotalstorno: {$sum: {$cond:[{$eq: ['$storno', true]},'$total', 0]}}   }}]
          // moment().startOf('quarter')


          // this month, quarter, year stats
          vm.thisyear = {};

          // dummy object for zero results
          let emptystat = {
            avg: 0.00,
            card: 0.00,
            cash: 0.00,
            discount: 0.00,
            invcount: 0,
            max: 0.00,
            min: 0.00,
            netto: 0.00,
            nettodiscounted: 0.00,
            open: 0.00,
            paid: 0.00,
            stddev: 0.00,
            storno: 0.00,
            stornocount: 0,
            tax: 0.00,
            taxdiscounted: 0.00,
            total: 0.00,
            totalcount: 0
          };


          let todayquerycash = [mongomatchstartend(moment().locale('de').startOf('day').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('cash', 'this')];
          let todayquerycheck = [mongomatchstartend(moment().locale('de').startOf('day').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('check', 'this')];

          let thisweekquerycash = [mongomatchstartend(moment().locale('de').startOf('week').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('cash', 'this')];
          let thisweekquerycheck = [mongomatchstartend(moment().locale('de').startOf('week').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('check', 'this')];

          let thismonthquerycash = [mongomatchstartend(moment().startOf('month').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('cash', 'this')];
          let thismonthquerycheck = [mongomatchstartend(moment().startOf('month').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('check', 'this')];

          let thisquarterquerycash = [mongomatchstartend(moment().startOf('quarter').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('cash', 'this')];
          let thisquarterquerycheck = [mongomatchstartend(moment().startOf('quarter').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('check', 'this')];

          let thisyearquerycash = [mongomatchstartend(moment().startOf('year').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('cash', 'this')];
          let thisyearquerycheck = [mongomatchstartend(moment().startOf('year').toISOString(), moment().add(1, 'days').toISOString()),
            mongogenblock('check', 'this')];

          // cashinvoices today
          $http.post('/routes/cashinvoices/aggregate', todayquerycash).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.todaycashstats = response.data;
              }
              else {
                vm.thisyear.todaycashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('todayquerycash Aggregate failed: ', response);
            });

          // checkinvoices today
          $http.post('/routes/checkinvoices/aggregate', todayquerycheck).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.todaycheckstats = response.data;
              }
              else {
                vm.thisyear.todaycheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thismonthquerycheck Aggregate failed: ', response);
            });


          // cashinvoices this week
          $http.post('/routes/cashinvoices/aggregate', thisweekquerycash).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.weekcashstats = response.data;
              }
              else {
                vm.thisyear.weekcashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.error('thisweekquerycash Aggregate failed: ', response);
            }
          );

          // checkinvoices this week
          $http.post('/routes/checkinvoices/aggregate', thisweekquerycheck).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.weekcheckstats = response.data;
              }
              else {
                vm.thisyear.weekcheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thisweekquerycheck Aggregate failed: ', response);
            });


          // cashinvoices this month
          $http.post('/routes/cashinvoices/aggregate', thismonthquerycash).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.monthcashstats = response.data;
              }
              else {
                vm.thisyear.monthcashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thismonthquerycash Aggregate failed: ', response);
            });

          // checkinvoices this month
          $http.post('/routes/checkinvoices/aggregate', thismonthquerycheck).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.monthcheckstats = response.data;
              }
              else {
                vm.thisyear.monthcheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thismonthquerycheck Aggregate failed: ', response);
            });

          // cashinvoices this quarter
          $http.post('/routes/cashinvoices/aggregate', thisquarterquerycash).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.quartercashstats = response.data;
              }
              else {
                vm.thisyear.quartercashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thisquarterquerycash Aggregate failed: ', response);
            });

          // checkinvoices this quarter
          $http.post('/routes/checkinvoices/aggregate', thisquarterquerycheck).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.quartercheckstats = response.data;
              }
              else {
                vm.thisyear.quartercheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thisquarterquerycheck Aggregate failed: ', response);
            });

          // cashinvoices this year
          $http.post('/routes/cashinvoices/aggregate', thisyearquerycash).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.yearcashstats = response.data
              }
              else {
                vm.thisyear.yearcashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thisyearquerycash Aggregate failed: ', response);
            });

          // checkinvoices this year
          $http.post('/routes/checkinvoices/aggregate', thisyearquerycheck).then(
            function success(response) {
              if (!angular.equals({}, response.data)) {
                vm.thisyear.yearcheckstats = response.data;
              }
              else {
                vm.thisyear.yearcheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('thisyearquerycheck Aggregate failed: ', response);
            });


          // monthly stats for the whole business period
          let monthlyquerycash = [{$match: {test: false}}, mongogenblock('cash', 'month')];
          let monthlyquerycheck = [{$match: {test: false}}, mongogenblock('check', 'month')];


          $log.debug('monthlyquerycash: ', monthlyquerycash);
          // cashinvoices per month
          $http.post('/routes/cashinvoices/aggregate', monthlyquerycash).then(
            function success(response) {
              $log.debug('monthlyquerycash response: ', response);
              if (angular.isArray(response.data) && response.data.length > 0) {
                vm.monthlycashstats = response.data;
                $log.debug('monthlycashstats: ', vm.monthlycashstats);
              }
              else if (angular.isObject(response.data)) {
                vm.monthlycashstats = response.data;
              } else {
                vm.monthlycashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('monthlychash Aggregate failed: ', response);
            });

          // checkinvoices per month
          $http.post('/routes/checkinvoices/aggregate', monthlyquerycheck).then(
            function success(response) {
              $log.debug('monthlyquerycheck response: ', response);
              if (angular.isArray(response.data) && response.data.length > 0) {
                vm.monthlycheckstats = response.data;
                $log.debug('monthlycheckstats: ', vm.monthlycheckstats);
              }
              else if (angular.isObject(response.data)) {
                vm.monthlycheckstats = response.data;
              } else {
                vm.monthlycheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('monthlyquerycheck Aggregate failed: ', response);
            });

          // yearly stats for the whole business period
          let yearlyquerycash = [{$match: {test: false}}, mongogenblock('cash', 'year')];
          let yearlyquerycheck = [{$match: {test: false}}, mongogenblock('check', 'year')];

          // chashinvoices per year
          $http.post('/routes/cashinvoices/aggregate', yearlyquerycash).then(
            function success(response) {
              $log.debug('yearlycashstats response: ', response);
              if (angular.isArray(response.data) && response.data.length > 0) {
                vm.yearlycashstats = response.data;
                $log.debug('yearlycashstats: ', vm.yearlycashstats);
              }
              else if (angular.isObject(response.data)) {
                vm.yearlycashstats = response.data;
              } else {
                vm.yearlycashstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('yearlycashstats Aggregate failed: ', response);
            });

          // Checkinvoices per year
          $http.post('/routes/checkinvoices/aggregate', yearlyquerycheck).then(
            function success(response) {
              $log.debug('yearlyquerycheck response: ', response);

              if (angular.isArray(response.data) && response.data.length > 0) {
                vm.yearlycheckstats = response.data;
                $log.debug('yearlycheckstats: ', vm.yearlycheckstats);
              }
              else if (angular.isObject(response.data)) {
                vm.yearlycheckstats = response.data;
              } else {
                vm.yearlycheckstats = angular.copy(emptystat);
              }
            },
            function error(response) {
              $log.debug('yearlycheckstats Aggregate failed: ', response);
            });


          function mongomatchstartend(start, end) {
            return {
              $match: {
                $and: [
                  {date: {$gt: start}},
                  {date: {$lt: end}},
                  {test: false}
                ]
              }
            };
          }

          function mongogenblock(type, id) {
            let specficquery = {};
            let groupid = {};
            if (id === 'month') {
              groupid = {
                year: {$substr: ['$date', 0, 4]},
                month: {$substr: ['$date', 5, 2]}
              };
            }
            else if (id === 'year') {
              groupid = {
                year: {$substr: ['$date', 0, 4]}
              };
            }
            else {
              groupid = 1;
            }


            if (type === 'cash') {
              specficquery = {
                $group: {
                  _id: groupid, totalcount: {$sum: 1},
                  invcount: {$sum: {$cond: [{$eq: ['$storno', false]}, 1, 0]}},
                  stornocount: {$sum: {$cond: [{$eq: ['$storno', true]}, 1, 0]}},
                  total: {$sum: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  netto: {$sum: {$cond: [{$eq: ['$storno', false]}, '$netto', 0]}},
                  nettodiscounted: {$sum: {$cond: [{$eq: ['$storno', false]}, '$nettodiscounted', 0]}},
                  discount: {$sum: {$cond: [{$eq: ['$storno', false]}, '$discount', 0]}},
                  tax: {$sum: {$cond: [{$eq: ['$storno', false]}, '$tax', 0]}},
                  taxdiscounted: {$sum: {$cond: [{$eq: ['$storno', false]}, '$taxdiscounted', 0]}},
                  storno: {$sum: {$cond: [{$eq: ['$storno', true]}, '$total', 0]}},
                  avg: {$avg: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  stddev: {$stdDevPop: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  max: {$max: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  min: {$min: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  cash: {
                    $sum: {
                      $cond: [
                        {
                          $and: [
                            {$eq: ['$storno', false]},
                            {$eq: ['$paytype', 'cash']}
                          ]
                        }, '$total', 0]
                    }
                  },
                  card: {
                    $sum: {
                      $cond: [
                        {
                          $and: [
                            {$eq: ['$storno', false]},
                            {$eq: ['$paytype', 'card']}
                          ]
                        }, '$total', 0]
                    }
                  }
                }
              };
            }
            else if (type === 'check') {
              specficquery = {
                $group: {
                  _id: groupid, totalcount: {$sum: 1},
                  invcount: {$sum: {$cond: [{$eq: ['$storno', false]}, 1, 0]}},
                  stornocount: {$sum: {$cond: [{$eq: ['$storno', true]}, 1, 0]}},
                  total: {$sum: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  netto: {$sum: {$cond: [{$eq: ['$storno', false]}, '$netto', 0]}},
                  nettodiscounted: {$sum: {$cond: [{$eq: ['$storno', false]}, '$nettodiscounted', 0]}},
                  discount: {$sum: {$cond: [{$eq: ['$storno', false]}, '$discount', 0]}},
                  tax: {$sum: {$cond: [{$eq: ['$storno', false]}, '$tax', 0]}},
                  taxdiscounted: {$sum: {$cond: [{$eq: ['$storno', false]}, '$taxdiscounted', 0]}},
                  storno: {$sum: {$cond: [{$eq: ['$storno', true]}, '$total', 0]}},
                  avg: {$avg: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  stddev: {$stdDevPop: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  max: {$max: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  min: {$min: {$cond: [{$eq: ['$storno', false]}, '$total', 0]}},
                  open: {
                    $sum: {
                      $cond: [
                        {
                          $and: [
                            {$eq: ['$storno', false]},
                            {$eq: ['$paid', false]}
                          ]
                        }, '$total', 0]
                    }
                  },
                  paid: {
                    $sum: {
                      $cond: [
                        {
                          $and: [
                            {$eq: ['$storno', false]},
                            {$eq: ['$paid', true]}
                          ]
                        }, '$total', 0]
                    }
                  }
                }
              };
            }

            return specficquery;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
